import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NoDataImg from "../../../Assets/img/image 12.png";
import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Select from "react-select"; // Import react-select

const UserTable = () => {
    const [rows, setRows] = useState([]);
    const [members, setMembers] = useState([]);
    const [selectedMember, setSelectedMember] = useState(null);
    const [memberOptions, setMemberOptions] = useState([]);
    const [search, setSearch] = useState(null);
    const navigate = useNavigate();

    const [isSubscribed, setIsSubscribed] = useState("no");

    useEffect(() => {
        const subscriptionStatus = sessionStorage.getItem("subscription_status");
        setIsSubscribed(subscriptionStatus === "yes");
    }, [isSubscribed]);

    useEffect(() => {
        const memData = sessionStorage.getItem("members");
        if (memData) {
            setMembers(JSON.parse(memData));
        } else {
            setMembers([]);
        }
    }, []);

    useEffect(() => {
        fetchAllUser();
    }, []);

    useEffect(() => {
        if (selectedMember || search) {
            const filterData = rows.filter((row) => {
                // Check if selectedMember exists and matches the pk_user_key
                const memberMatch = selectedMember ? row.pk_user_key === selectedMember.value : true;

                const searchMatch = search
                    ? row.user_name.toLowerCase().includes(search.toLowerCase()) ||
                      row.date_of_joining.toLowerCase().includes(search.toLowerCase()) ||
                      row.user_level == search ||
                      row.user_sub_count == search
                    : true;

                // Return true if both match
                return memberMatch && searchMatch;
            });
            setMembers(filterData);
        } else {
            setMembers(rows);
        }
    }, [selectedMember, search, rows]);

    const fetchAllUser = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllMemberData",
            created_by: sessionStorage.getItem("pk_user_key"),
        });

        const output = response.data;

        if (output.length > 0) {
            setRows(output);
            const options = output.map((member) => ({
                value: member.pk_user_key,
                label: member.user_name,
            }));
            setMemberOptions(options);
        }
    };

    const handleAddMemberClick = () => {
        navigate("/addmember");
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    };

    return (
        <section className="pb-3">
            <div className="main-content">
                <h3 className="page-title">Downline Members</h3>
                <div className="row">
                    <div className="col-12 px-2">
                        <div className="m-wrapper mt-2 p-3">
                            <div className="input-group mb-3 d-flex gap-3 align-items-center justify-content-between">
                                {/* <div className="net-input-field mb-0">
                                    <Select
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                height: "42px", 
                                                border: "1px solid grey", 
                                                borderRadius: "0.25rem", 
                                            }),
                                            valueContainer: (base) => ({
                                                ...base,
                                                padding: "0",
                                                alignItems: "center", 
                                                display: "flex", 
                                                height: "100%", 
                                            }),
                                        }}
                                        options={memberOptions}
                                        onChange={setSelectedMember}
                                        placeholder="Select a member"
                                        className="multi-selector"
                                        isClearable

                                    />
                                </div> */}
                                {/* <div className="net-input-field mb-0">
                                        <input type="date" className="form-control" name="date" id="date" />
                                    </div> */}
                                <div className="net-input-field">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search"
                                        aria-label="Search"
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>
                                {/* <div className="net-input-field d-flex justify-content-center">
                                        <button
                                            className="btn btn-light border border-dark ms-2 report-btn rounded-2"
                                            type="button"
                                        >
                                            Get Report
                                        </button>
                                    </div> */}
                                <div className="btn-add">
                                    <button
                                        type="button"
                                        className="btn btn-dark text-white rounded-3 addmember-btn d-flex justify-content-center align-items-center z-0"
                                        // style={{zIndex:0}}
                                        onClick={handleAddMemberClick}
                                        disabled={!isSubscribed}
                                    >
                                        <span>
                                            <i className="bi bi-plus"></i>
                                        </span>
                                        Add Member
                                    </button>
                                </div>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th className="bg-5">User Name</th>
                                            <th className="bg-5">Current Level</th>
                                            <th className="bg-5">Downline Members</th>
                                            <th className="bg-5">Date of Joining</th>
                                            <th className="bg-5">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {members.length > 0 ? (
                                            members.map((member, index) => (
                                                <tr key={index}>
                                                    <td>{member.user_name}</td>
                                                    <td>{member.user_level || "0"}</td>
                                                    <td>{member.user_sub_count || "0"}</td>
                                                    {/* <td>{formatDate(member.created_on)}</td> */}
                                                    <td>{member.date_of_joining}</td>
                                                    <td>
                                                        {/* Pending */}
                                                        <div className="actbtn-grp">
                                                            <Button
                                                                as={Link}
                                                                to={`/editmember/${member.pk_user_key}`}
                                                                className="edit-icon btn btn-outline-dark"
                                                                data-bs-toggle="tooltip"
                                                                title="Edit"
                                                            >
                                                                <i className="fa-solid fa-pen-to-square"></i>
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">
                                                    <div className="d-flex flex-column align-items-center">
                                                        <img src={NoDataImg} alt="No data" className="img-fluid" />
                                                        <span>No Data available</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            <style jsx>{`
                                .report-btn {
                                    width: 140px;
                                }

                                .net-input-field input,
                                select {
                                    width: 252px !important;
                                    height: 42px;
                                    padding: 11px;
                                    border-radius: 4px;
                                    outline: none;
                                    transition: border-color 0.3s;
                                }
                                .w-90 {
                                    width: 90%;
                                }
                                .edit-icon:hover {
                                    color: #fff !important;
                                }
                                .css-r4nu3f-control {
                                    border-color: unset !important;
                                    box-shadow: unset !important;
                                }
                                // .btn-add > button{
                                //     z-index:0 !important;
                                // }
                            `}</style>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default UserTable;
